module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_de-e424dc526edf461cba43c507f1c3b0b4.png";